import { useContext, useState } from "react";
import {
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import { customPriceRedirectionRules } from "../../utils/customPriceRules/priceRules";
import BookingSummary from "../../components/booking-summary/BookingSummary";
import { BookingContext } from "../../providers/BookingProvider";
import { createPayment } from "../../services/payment/PaymentService";
import { getTotalPriceOfServiceWithPatients } from "../../utils/pricesService";

export const AppointmentConfirmation = () => {
  const history = useHistory();

  // global booking state
  const { booking, organization } = useContext(BookingContext);

  // to render a loading element
  const [loading, setLoading] = useState(false);

  const confirmAppointment = async () => {
    setLoading(true);

    // check if redirect
    const customRedirect = customPriceRedirectionRules(organization, booking);

    if (customRedirect) {
      history.push(customRedirect);
    } else {
      const email = booking.customer.email;

      const paymentRedirectUrl = await createPayment(
        getTotalPriceOfServiceWithPatients(
          booking.products.reduce((acc, prod) => acc + prod.price, 0),
          booking.patients.length,
          booking.products.reduce((acc, prod) => acc + prod.servicePrice, 0),
          organization,
          booking.discount
        )[2],
        booking.id,
        email
      );

      window.location.href = paymentRedirectUrl;
    }
  };

  const previuousPage = () => {
    history.go(-1);
  };

  return (
    <Container
      maxWidth={false}
      style={{ backgroundColor: "#F0F2F9", paddingTop: 60, minHeight: "100vh" }}
    >
      {!loading ? (
        <Container>
          <Grid container spacing={10}>
            <Grid item xs={12} sm={10}>
              <Typography variant={"h5"} component={"h2"}>
                ¡Estás a un paso de confirmar tu cita!
              </Typography>

              <Typography color={"primary"} variant={"body1"} component={"h2"}>
                Antes de confirmar, mira el resumen y fíjate que todo esté
                correcto 🕵️‍♂️
              </Typography>
            </Grid>

            <Grid item xs={12} sm={10}>
              <BookingSummary booking={booking} />
            </Grid>

            {/* continue button */}
            <Grid item xs={12} sm={11}>
              <Button
                variant={"contained"}
                color={"primary"}
                style={{ float: "right" }}
                onClick={confirmAppointment}
              >
                Confirmar cita
              </Button>
              <Button
                variant={"contained"}
                color={"secondary"}
                style={{ float: "left" }}
                onClick={previuousPage}
              >
                Volver
              </Button>
            </Grid>
          </Grid>
        </Container>
      ) : (
        // loading
        <Grid
          item
          xs={12}
          sm={8}
          style={{ display: "flex", justifyContent: "center", margin: 10 }}
        >
          <CircularProgress />
          <p style={{ marginLeft: 10 }}>Cargando...</p>
        </Grid>
      )}
    </Container>
  );
};
